/*
 * Faculty Module Functionaity
 */

jQuery(document).ready(function($) {
    $('.facuilty_block .btn--expand').on('click', function(e) {
        e.preventDefault();
        var t = $(this);
        var summary = t.siblings('.bio-summary');
        var wrapper = t.closest('.bio-summary-wrapper');

        let expanded = t[0].getAttribute('aria-expanded') === 'true' || false;
        t[0].setAttribute('aria-expanded', !expanded);

        wrapper.toggleClass('expanded');
    });
});